/*
  Operator mutations
*/
export default {
  setDefaultKeys (state, payload) {
    state.default = payload
  }
}
